// extracted by mini-css-extract-plugin
export default {"formControlLabel":"FormControlLabel_formControlLabel__q7jif"};